var nuevoInspector = angular.module('posicionamientosAdmin');

nuevoInspector.controller('nuevoPosicionamientoAdminController', ['$scope', '$routeParams', '$location', 'posicionamientosAdminService', 'authenticationInfo', 'authenticationService', function ($scope, $routeParams, $location, posicionamientosAdminService, authenticationInfo, authenticationService) {
    $scope.error = '';
    $scope.authentication = authenticationInfo;

    $scope.gestionPosicionamientos = function () {
        $location.path('/admin/editarPosicionamientos/' + $routeParams.id);
    }

    $scope.guardarPosicionamiento = function () {
        var posicionamiento = new Object();
        posicionamiento.InspeccionId = $routeParams.id;
        posicionamiento.Nombre = $scope.Nombre;
        posicionamiento.CoordenadaX = $scope.CoordenadaX;
        posicionamiento.CoordenadaY = $scope.CoordenadaY;
        posicionamiento.CoordenadaZ = $scope.CoordenadaZ;
        posicionamiento.RotX = $scope.RotX;
        posicionamiento.RotY = $scope.RotY;
        posicionamiento.RotZ = $scope.RotZ;

        posicionamientosAdminService.post(posicionamiento).then(function (response) {
                var result = response.data;
                alert(result);
                $location.path('/admin/editarPosicionamientos/' + $routeParams.id);
                //$location.path("/Admin");
            }).catch(function (response) {
                $scope.error = inspectoresAdminService.obtenerPrimerErrorModelState(response.data);
                alert($scope.error);
            });
        }
    }]);